import { IconLogout } from '@tabler/icons-react';
import { Button } from '@mantine/core';
import { useAuth } from '@/contexts/AuthContext';

type NavbarActionsProps = {
  /** Menu do celular: botão ocupa a largura toda. */
  fullWidth?: boolean;
  ml?: number;
};

/**
 * Botões de conta do topo do site, compartilhados pelo menu do desktop e pelo menu do celular
 * (DrawerCollapse). Mude aqui para os dois menus mudarem juntos.
 */
export default function NavbarActions({ fullWidth = false, ml }: NavbarActionsProps) {
  const { currentUser, logout } = useAuth();

  if (!currentUser) {
    return (
      <Button
        tt="uppercase"
        ml={ml}
        fullWidth={fullWidth}
        color="principal.9"
        fz={17}
        component="a"
        href="/login"
        title="Acessar minha conta"
        aria-label="Entrar na minha conta"
      >
        entrar
      </Button>
    );
  }

  return (
    <Button
      ml={ml}
      fullWidth={fullWidth}
      fz={17}
      onClick={logout}
      component="a"
      variant="default"
      href="/"
      rightSection={<IconLogout size={24} />}
      title="Sair da minha conta"
      aria-label="Sair da minha conta"
    >
      SAIR
    </Button>
  );
}
